"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecisionNodeEditor = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ConditionEditor_1 = require("./ConditionEditor");
var styles = __importStar(require("./AlgorithmEditor.css"));
var operatorMapping = Object.freeze({
    "highly engaged": ">=",
    engaged: ">=",
    disengaged: "<=",
    "highly disengaged": "<=",
});
var DecisionNodeEditor = function (_a) {
    var engagementLevel = _a.engagementLevel, node = _a.node, onChange = _a.onChange;
    var operator = operatorMapping[engagementLevel];
    var withinTimeCriteria = getWithinTime(node);
    function updateConditions(updatedConditions) {
        onChange(__assign(__assign({}, node), { values: updatedConditions }));
    }
    function addCondition(metric, threshold) {
        var newNode = {
            kind: "EXPRESSION",
            values: __assign({ metric: metric, threshold: threshold, operator: operator }, withinTimeCriteria),
        };
        var updatedConditions = __spreadArray(__spreadArray([], __read(node.values), false), [newNode], false);
        updateConditions(updatedConditions);
    }
    function onConditionChange(index, updatedLeafNode) {
        var updatedConditions = __spreadArray([], __read(node.values), false);
        updatedConditions.splice(index, 1, updatedLeafNode);
        updateConditions(updatedConditions);
    }
    function onConditionDelete(index) {
        var updatedConditions = node.values.filter(function (value, i) { return i !== index; });
        updateConditions(updatedConditions);
    }
    function setWithinTimeValue(newTimeValue) {
        var parsedValue = parseInt(newTimeValue);
        var newValueAsInt = Number.isNaN(parsedValue) ? 0 : parsedValue;
        var updatedConditions = node.values.map(function (_a) {
            var kind = _a.kind, values = _a.values;
            if (kind === "EXPRESSION") {
                return { kind: kind, values: __assign(__assign({}, values), { timeValue: newValueAsInt }) };
            }
            else {
                return { kind: kind, values: values };
            }
        });
        updateConditions(updatedConditions);
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l" },
        react_1.default.createElement("div", { className: styles.decisionNodeGrid },
            react_1.default.createElement(AnyAllSelector, { className: styles.anyAllSelector, rootNode: node, onChange: function (newValue) { return onChange(__assign(__assign({}, node), { kind: newValue })); } }),
            react_1.default.createElement(kaleidoscope_1.Text, { className: styles.anyAllDescriptor, element: "div", size: "s" }, "of the following conditions are met:"),
            react_1.default.createElement("div", { className: styles.dottedVerticalLine }),
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.conditionsList, paddingTop: "m", paddingBottom: "xs", gap: "xs" }, node.values.map(function (v, index) {
                if (v.kind !== "EXPRESSION") {
                    return react_1.default.createElement(kaleidoscope_1.Text, null, "Unexpected data in algorithm configuration");
                }
                return (react_1.default.createElement(ConditionEditor_1.ConditionEditor, { key: index, leafNode: v, onChange: function (updatedLeafNode) { return onConditionChange(index, updatedLeafNode); }, onDelete: function () { return onConditionDelete(index); } }));
            })),
            react_1.default.createElement("div", { className: styles.addCondition },
                react_1.default.createElement(AddCondition, { node: node, addCondition: addCondition }))),
        node.values.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles.horizontalDivider }),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "m" },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Within the last"),
                react_1.default.createElement(kaleidoscope_1.TextInput, { className: styles.timeValueInput, type: kaleidoscope_1.TextInputType.Number, inputMode: "numeric", value: "".concat(withinTimeCriteria.timeValue), onChange: setWithinTimeValue, label: "Time value", labelHidden: true }),
                react_1.default.createElement("div", { className: styles.timeUnits },
                    react_1.default.createElement(kaleidoscope_1.Text, null, withinTimeCriteria.timeUnits)))))));
};
exports.DecisionNodeEditor = DecisionNodeEditor;
function getWithinTime(decisionNode) {
    var firstLeafNode = decisionNode.values.find(function (_a) {
        var kind = _a.kind;
        return kind === "EXPRESSION";
    });
    if (firstLeafNode && firstLeafNode.kind === "EXPRESSION") {
        var _a = firstLeafNode.values, timeUnits = _a.timeUnits, timeValue = _a.timeValue;
        return { timeUnits: timeUnits, timeValue: timeValue };
    }
    return {
        timeUnits: "days",
        timeValue: 5,
    };
}
var AnyAllSelector = function (_a) {
    var rootNode = _a.rootNode, className = _a.className, onChange = _a.onChange;
    return (react_1.default.createElement(kaleidoscope_1.Select, { className: className, label: "Select ALL or ANY", labelHidden: true, autoStack: true, size: "xs", value: rootNode.kind, onChange: function (newValue) { return onChange(newValue); } },
        react_1.default.createElement(kaleidoscope_1.SelectOption, { value: "AND" }, "All"),
        react_1.default.createElement(kaleidoscope_1.SelectOption, { value: "OR" }, "Any")));
};
var MAX_CONDITION_COUNT = 2;
var addConditionsConfig = Object.freeze([
    { metric: "PageViewCount", displayName: "Page views", startingThreshold: 2 },
    { metric: "PageViewDuration", displayName: "Minutes spent on page", startingThreshold: 5 },
]);
var AddCondition = function (_a) {
    var node = _a.node, addCondition = _a.addCondition;
    var atMaxConditions = node.values.length >= MAX_CONDITION_COUNT;
    var commonButtonProps = {
        icon: react_1.default.createElement(icons_1.Add, null),
        size: kaleidoscope_1.ButtonSize.Small,
        isRound: true,
        type: kaleidoscope_1.ButtonType.Secondary,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, atMaxConditions ? (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, commonButtonProps, { tooltip: {
            content: "",
            size: kaleidoscope_1.TooltipSize.Large,
        }, disabled: true, disabledReason: "A maximum of two conditions is allowed per engagement level" }))) : (react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, commonButtonProps, { tooltip: {
                content: "Add condition",
                size: kaleidoscope_1.TooltipSize.Small,
            } })), size: "medium", autoStack: true }, addConditionsConfig.map(function (_a) {
        var metric = _a.metric, displayName = _a.displayName, startingThreshold = _a.startingThreshold;
        var conditionAlreadyExists = node.values.some(function (leafNode) { return leafNode.kind === "EXPRESSION" && leafNode.values.metric === metric; });
        return (react_1.default.createElement(kaleidoscope_1.Tooltip, { key: metric, content: "A maximum of one of each condition type may be added", show: conditionAlreadyExists ? undefined : false, size: kaleidoscope_1.TooltipSize.Large, wrapTarget: true },
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () { return addCondition(metric, startingThreshold); }, disabled: conditionAlreadyExists }, displayName)));
    })))));
};
